import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { getEmpsProfilesAPI } from '../../../services/employee'
import { Col, Image, Row } from 'react-bootstrap'
import moment from 'moment'
import ImgBGProfile from '../../../images/bg-profile.png'
import imgUser from '../../../images/user.png'

export default function ProfileDetail() {
  // const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const code = searchParams.get('code')
  const orgId = searchParams.get('orgId')

  const [profile, setData] = useState([])
  const [report, setReport] = useState({})

  useEffect(() => {
    const getEmpsProfiles = async () => {
      const param = { orgId, code }
      const result = await getEmpsProfilesAPI(param)
      if (!result) return
      if (result.status) {
        setData(result.result[0])
        setReport(result.result[0]?.detail_report_to)
      }
    }
    if (orgId) {
      getEmpsProfiles()
    }
  }, [orgId, code])

  return (
    <>
      <div className="position-relative mt-3">
        <Image src={ImgBGProfile} fluid />
        <div
          className="position-absolute"
          style={{
            top: '60%',
            left: '20%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Image
            src={profile?.image_url ?? imgUser}
            fluid
            style={{ width: '80px', height: '80px', objectFit: 'cover' }}
            className="rounded-circle bg-white"
            onError={(event) => {
              event.target.src = imgUser
              event.onerror = null
            }}
          />
        </div>
      </div>
      <p className="text-center mb-0 mt-3">
        {/* {profile?.title_en} */}
        {profile?.name_en || '-'} {profile?.surname_en || '-'}
      </p>
      <p className="text-center fw-light small">
        {/* {profile?.title_th}  */}
        {profile?.name_th || '-'} {profile?.surname_th || '-'} (
        {profile?.nickname_th || '-'})
      </p>
      <div className="m-1 p-2 rounded-3" style={{ backgroundColor: '#EEF4FF' }}>
        <div className="d-flex justify-content-between border-bottom mt-3 pb-2">
          <p className="mb-2 font-small-2">Start Date</p>
          <p className="font-small-2 mb-2 fw-light text-muted">
            {profile?.start_date
              ? moment(profile.start_date).format('DD MMMM YYYY')
              : '-'}
          </p>
        </div>
        <Row className="mt-3">
          <Col xl={8}>
            <p className="font-small-2  m-0">Code</p>
            <p className="font-small-2 fw-light text-muted ">{code}</p>
          </Col>
          <Col md={4}>
            <p className="font-small-2 m-0">Level</p>
            <p className="font-small-2 fw-light text-muted">
              {profile?.level_id || '-'}
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <p className="font-small-2 m-0">Direct Report </p>
            <p className="font-small-2 fw-light text-muted">
              {profile?.detail_report_to?.title_en || '-'}{' '}
              {profile?.detail_report_to?.name_en || '-'}{' '}
              {profile?.detail_report_to?.surname_en || '-'}
            </p>
          </Col>
          {/* <Col md={4}>
            <p className="font-small-2 m-0">Status </p> */}
          <Col xl={4}>
            <p className="font-small-2 m-0">Type </p>
            <p className="font-small-2 fw-light text-muted">
              {profile?.type || '-'}
            </p>
          </Col>
        </Row>

        <p className="font-small-2 m-0">Group </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.division_en || '-'}
          <span>{` (${profile?.division || ''})`}</span>
        </p>

        <p className="font-small-2 m-0">Division </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.faction_en || '-'}
          <span>{` (${profile?.faction || ''})`}</span>
        </p>
        <p className="font-small-2 m-0">Department </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.department_en || '-'}
          <span>{` (${profile?.department || ''})`}</span>
        </p>

        <p className="font-small-2 m-0">Team </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.team_en || '-'}
        </p>

        <p className="font-small-2 m-0">Position </p>
        <p className="font-small-2 fw-light text-muted mb-5">
          {profile?.position_en || '-'}
        </p>
      </div>
    </>
  )
}
